import { QUESTIONNAIRE_DETAILS } from "../_constants/questionnaireDetails.constant"
import { getQuestionnaireDetails } from "../apis/questionnaireApis"

export const clearQuestionnaireDetailsStore = () => {
    return { type: QUESTIONNAIRE_DETAILS.CLEAR }
}
const fetchQuestionnaireDetails = (questionnaireId) => {
    return async (dispatch) => {
        dispatch({ type: QUESTIONNAIRE_DETAILS.SET_LOADING_DETAILS, data: true });
        try {
            const res = await getQuestionnaireDetails(questionnaireId)
            dispatch({
                type: QUESTIONNAIRE_DETAILS.SET_QUESTIONNAIRE_DETAILS_DATA, data: res.data
            });
        } catch (e) {
            dispatch({ type: QUESTIONNAIRE_DETAILS.SET_LOADING_DETAILS, data: false });
        }
    }
}

const changeSectionIndex = (sectionIndex)=>{
     return async (dispatch) => {
        dispatch({ type: QUESTIONNAIRE_DETAILS.CHANGE_SECTION_INDEX, data: sectionIndex });
    }
}

export const questionnaireDetailActions = {
    fetchQuestionnaireDetails,
    clearQuestionnaireDetailsStore,
    changeSectionIndex
}